import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { PoContainerModule, PoButtonModule, PoWidgetModule } from '@po-ui/ng-components';

@Component({
  selector: 'app-filter-dropdown',
  imports: [CommonModule, PoContainerModule, PoButtonModule, PoWidgetModule],
  templateUrl: './filter-dropdown.component.html',
  styleUrl: './filter-dropdown.component.css'
})
export class FilterDropdownComponent {
  @Output() onFilterClick = new EventEmitter();
  @Output() onCleanFilterClick = new EventEmitter();

  cleanFilter() {
    this.onCleanFilterClick.emit();
  }

  onFilter() {
    this.onFilterClick.emit();
  }
}
